var map = {
	"./treatments-directory-dashboard-desktop-en.jpg": "db77",
	"./treatments-directory-dashboard-desktop-fr.jpg": "9857",
	"./treatments-directory-dashboard-desktop-ru.jpg": "c644"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d3e7";